import styles from '../../RiskIndicators.module.scss';
import { ctaPurpleRight } from '../../../../assets/hostedassets';
import { useRiskIndicatorStates } from '../../useRiskIndicatorStates';
import { TYPES } from '../../RiskIndicatorConstants';
import { Row } from '../../RiskIndicators';
import { Header } from './RiskIndicatorHeaders';
import { normalizeNameKey } from '../../../../utils/utils';
import { useAppDispatch } from '../../../../app/hooks';
import { removeTooltipContent, setTooltipContent } from '../../../../store/tooltip/tooltip_actions';

interface RiskIndicatorRowsProps {
    rows: Row[];
    setRows: React.Dispatch<React.SetStateAction<Row[]>>;
    headers: Header[];
    isPDFReport?: boolean;
    onViewReport?: (docId: string, name: string) => void;
    onOpenRegulatoryRisk?: (row: Row, checkType: string) => void;
}

const RiskIndicatorRows = ({ rows, setRows, headers, isPDFReport = false, onViewReport, onOpenRegulatoryRisk }: RiskIndicatorRowsProps) => {
    const { hoveredIndex, setHoveredIndex, getRowImage, getRiskIndicator } = useRiskIndicatorStates({
        rows,
        setRows,
        autoFetch: false,
    });
    const dispatch = useAppDispatch();

    return (
        <>
            {rows?.map((row, index) => (
                <div className={styles.TableRow} key={index} data-ri-director={normalizeNameKey(row?.name)}>
                    <div className={styles.StickyRows}>
                        <div className={styles.Name}>
                            <span>{getRowImage(row?.type)}</span>
                            <span
                                // Cell truncates — reveal full name + designation on hover via the shared
                                // tooltip component (matches Legal Cases).
                                className={styles.NameSpan}
                                onMouseEnter={(e) => {
                                    if (isPDFReport) return;
                                    const designationSuffix =
                                        row?.type === TYPES.INDIVIDUAL && row?.designation ? ` (${row.designation})` : '';
                                    dispatch(
                                        setTooltipContent({
                                            content: `${row?.name ?? ''}${designationSuffix}`,
                                            target: e.currentTarget,
                                            placement: 'top',
                                        }),
                                    );
                                }}
                                onMouseLeave={() => removeTooltipContent(dispatch)}
                            >
                                {row?.name}
                                {row?.type === TYPES.INDIVIDUAL && row?.designation && (
                                    <span className={styles.DesignationText}> ({row.designation})</span>
                                )}
                            </span>
                        </div>
                        {!isPDFReport && (
                            <span
                                className={styles.DownloadReport}
                                onClick={() => {
                                    if (!row?.docId || !onViewReport) return;
                                    onViewReport(row.docId, row.name);
                                }}
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                                style={{
                                    cursor: row?.docId ? 'pointer' : 'not-allowed',
                                }}
                            >
                                {row?.docId ? (
                                    <img src={ctaPurpleRight} alt="" width={14} height={14} />
                                ) : (
                                    <img src={ctaPurpleRight} alt="" width={14} height={14} className={styles.DownloadReportDisabled} />
                                )}
                            </span>
                        )}
                    </div>
                    {headers.map((header, headerIndex) => (
                        <div className={styles.TableRowItem} key={headerIndex}>
                            {getRiskIndicator(row?.riskProfile?.[header.key], row, header.key, onOpenRegulatoryRisk)}
                        </div>
                    ))}
                </div>
            ))}
        </>
    );
};

export default RiskIndicatorRows;
